module.exports = __webpack_public_path__ + "static/illustration-mobile-fe407bbade52e132ae4a1f4d55195993.svg";